const infractionStatus = {
  ANALYSIS: 'ANALYSIS',
  PENDING: 'PENDING',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  AGREED: 'AGREED',
  DISAGREED: 'DISAGREED',
  CANCELLED: 'CANCELLED'
};

module.exports = infractionStatus;
